<template>
  <div>
    <RouterLink
      :to="{ name: 'vacancy', params: { companyId: companyId, vacancyId: vacancy.id } }"
      class="text-decoration-none body-2"
    >
      {{ vacancy.title }}
      <VTooltip bottom>
        <template v-slot:activator="{ on }">
          <VIcon v-show="isLocked" size="13" color="grey" class="mt-n1 ml-2" v-on="on">
            {{ mdiLock }}
          </VIcon>
        </template>
        <span>
          {{ $t('invitationTip') }}
        </span>
      </VTooltip>
    </RouterLink>
    <div class="d-flex flex-md-column flex-wrap body-2 mb-1">
      <VacancySalary :salary="vacancy.salary" class="mr-4" />
      <div v-if="vacancy.address">
        {{ vacancy.address.city }}
      </div>
      <span v-else />
    </div>
    <div class="caption grey--text text--darken-1">
      <AppDateFormatted :value="vacancy.publishedFrom" />
    </div>
  </div>
</template>

<script>
import { mdiLock } from '@mdi/js';
import VacancySalary from '../Vacancy/VacancySalary.vue';
import AppDateFormatted from '../AppDateFormatted.vue';
import { isLocked } from '../Vacancy/functions';

export default {
  name: 'CompanyVacanciesListRow',
  components: { AppDateFormatted, VacancySalary },
  props: {
    companyId: {
      type: Number,
      required: true,
    },
    vacancy: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mdiLock,
    };
  },
  computed: {
    isLocked() {
      return isLocked(this.vacancy);
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  invitationTip: Available by invitation only
  salary: salary
</i18n>

<i18n locale="ru" lang="yaml">
  invitationTip: >-
    Пройти онлайн-собеседование на эту вакансию возможно только по приглашению работодателя.
  salary: з/п
</i18n>
